import { ToastProps } from '@chakra-ui/react';
import './CustomToast.css';

const isWide = (title: ToastProps['title'], description: ToastProps['description']) =>
  (typeof title === 'string' && title.length > 32) ||
  (typeof description === 'string' && description.length > 40);

const CustomToast = ({ onClose, title, description }: ToastProps) => (
  <div className={`toast${isWide(title, description) ? ' toast--wide' : ''}`} role="alert">
    <svg className='toast-icon' viewBox="0 0 256 256" aria-hidden="true">
      <path
        fill="currentColor"
        d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm-8-80V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,172Z"
      />
    </svg>
    <div className='toast-body'>
      <div className='toast-title'>{title}</div>
      {description && <div className='toast-description'>{description}</div>}
    </div>
    <button type="button" className='toast-close' onClick={onClose} aria-label="Close">
      <svg viewBox="0 0 256 256" aria-hidden="true">
        <path
          fill="currentColor"
          d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"
        />
      </svg>
    </button>
  </div>
);

export default CustomToast;
